import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export default function useDeleteReasonRefusal() {
  const [loading, setLoading] = useState(false);

  async function execute(reasonRefusalId: string, callback?: any) {
    try {
      setLoading(true);
      const response = await api.delete(
        `v1/backoffice/reasons-refusal/${reasonRefusalId}`,
      );

      if (response.status === 204) {
        toast.success(ToastMessages.reasonRefusal.success.deleteReasonRefusal);

        if (callback) {
          callback();
        }
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.reasonRefusal.error.deleteReasonRefusal);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
